module.exports = __webpack_public_path__ + "static/media/menus.97289106.jpg";